<p-card class="p-card container">
  <h3 i18n>Exigences de sélection</h3>

  <form class="flex flex-column gap-4" [formGroup]="form">
    <div class="grid">
      @for (extraRequirement of possibleExtraRequirements; track extraRequirement) {
        <p-checkbox
          class="col-4"
          [label]="extraRequirementsTranslations[extraRequirement][translate.getCurrentLanguageCode()]"
          [binary]="true"
          [value]="getExtraRequirementFormControl(extraRequirement).value"
          [formControl]="getExtraRequirementFormControl(extraRequirement)"></p-checkbox>
      }
    </div>

    <p class="mb-0" i18n>Détails supplémentaires</p>
    <textarea
      placeholder="Aa..."
      [formControl]="form.controls.note"
      [maxlength]="5000"
      [autoResize]="isReadonly"
      rows="4"
      class="w-full"
      pInputTextarea></textarea>

    @if (!isReadonly) {
      <p-button
        (onClick)="openSendExtraRequirementsPopup()"
        [loading]="isLoading"
        [disabled]="form.invalid"
        class="flex justify-content-end"
        icon="pi pi-check"
        i18n-label
        label="Commander les exigences"></p-button>
    }
    @if (existingExtraRequirementsInquiries.length) {
      <div>
        <p-divider class="m-0"><strong i18n>Commandes précédentes</strong></p-divider>
        <em-extra-requirements-inquiries
          [extraRequirementsInquiries]="existingExtraRequirementsInquiries"></em-extra-requirements-inquiries>
        <p-divider><strong i18n>Téléversement des PDFs d'exigences</strong></p-divider>
        <p-fileUpload
          id="dont-show-file-bytes"
          [disabled]="isReadonly"
          [class.remove-file-delete-button]="isReadonly"
          (onSelect)="onSelectDocuments($event)"
          (onRemove)="openRemoveExtraRequirementsPopup($event)"
          [multiple]="true"
          [files]="form.controls.files.value || []"
          [auto]="true"
          [maxFileSize]="5000000"
          [invalidFileSizeMessageSummary]="
            translate.currentLanguageIsFr() ? 'Taille du fichier invalide' : 'Invalid file size'
          "
          [invalidFileSizeMessageDetail]="''"
          [fileLimit]="4"
          accept=".pdf"
          i18n-chooseLabel
          chooseLabel="Choisir">
          <ng-template pTemplate="content">
            <div class="flex gap-3">
              @for (document of form.controls.files.value; track document) {
                <p-button
                  (onClick)="onDownloadDocument(document.name)"
                  class="btn--light-grey"
                  type="button"
                  [label]="document.name"
                  icon="pi pi-file-pdf"></p-button>
              }
            </div>
          </ng-template>
        </p-fileUpload>
      </div>
    }
    @if (form.controls.documents.value) {
      <div>
        <p-divider><strong i18n>Téléchargement des PDFs d'exigences</strong></p-divider>
        <div class="flex gap-3">
          @for (document of form.controls.documents.value; track document) {
            <p-button
              (onClick)="onDownloadDocument(document.name)"
              class="btn--light-grey"
              type="button"
              [label]="document.name"
              icon="pi pi-file-pdf"></p-button>
          }
        </div>
      </div>
    }
  </form>
</p-card>
